<template>
  <div class="k8m-wrapper">
    <div class="k8m-container">
      <div class="k8m-header">
        <RexBreadcrumbDropdownV3
          :routes="getCurrentRouteConfig"
          @onClickEvent="(data) => setCurrentTab(data)"
        />
        <K8MHeader v-if="!disableHeaders" />
      </div>
      <router-view />
    </div>
  </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex';
import RexBreadcrumbDropdownV3 from '@/rex-components/RexBreadcrumbDropdownV3.vue';
import K8MHeader from '@/components/K8M/K8MHeader.vue';
import { TEMPLATE_K8M } from '@/utils/constants';

export default {
  components: {
    K8MHeader,
    RexBreadcrumbDropdownV3,
  },
  data() {
    return {
      hideHeaders: ['k8mDetails', 'k8mPodDetails'],
    };
  },
  computed: {
    ...mapGetters('k8State/k8CommonState', ['getCurrentRouteConfig']),
    disableHeaders() {
      return this.hideHeaders.includes(this.$route.name);
    },
  },
  methods: {
    ...mapMutations('k8State/k8CommonState', ['setCurrentK8Tab']),
    ...mapMutations('globalState/app', ['setTemplate']),
    setCurrentTab(data) {
      this.setCurrentK8Tab(data.tab);
    },
  },
  mounted() {
    this.setTemplate(TEMPLATE_K8M);
  },
};
</script>

<style lang="scss" scoped>
.k8m-container {
  overflow: visible;
}
.k8m-header {
  margin-top: -2rem;
  position: sticky;
  top: 3.5rem;
  z-index: 1;
  background-color: $bg-primary;
}
.k8m-wrapper {
  width: 100%;
  @include flex-column;
  margin-top: 0.23rem;
}
</style>
